import { logout } from '@/auth';
import store from './../store';
import router from '@/router';


var intervalId;

export const setCounterInterval = () => {
    clearInterval(intervalId)
    intervalId = setInterval(() => {
        doCountAction()
    }, 1000)
}

export const doCountAction = () => {
    store.commit('tokenCounter/decrementCounter');

    var remainingSec = store.getters['tokenCounter/getExpInSecCounter']
    if(remainingSec <= 0){
        clearExpDate()
        logout()
        router.push('/login')
    }
}

export const setExpInSec = (expInSec) => {
    store.commit('tokenCounter/setExpInSec', expInSec);
}

export const setExpTime = (expTime) => {
    window.localStorage.setItem("expTime", expTime)
}

export const resetExpInSec = () => {
    var expTime = window.localStorage.getItem("expTime")
    if(!expTime)
        return
    
    setExpInSec(expTime)
    setCounterInterval()
}

export const clearExpDate = () => {
    window.localStorage.removeItem("expTime")
    clearInterval(intervalId)
}
